/* ag-set-attach.js - the SET-ATTACH card (marker `agsa`), plan set-attach v1.2 C3 (the
   card's own script; the add and the main button's price belong to assets/ag-attach.js, the
   shared attach coordinator, which this file registers with). The card has NO add to cart of its
   own; its checks tick matching pieces onto the page's own ADD TO CART.

   1. THE ROWS (one or two: Datch 2026-10-08, a desk offers the set's shelving unit and its
      credenza, a storage piece offers the desk and the other storage piece): the snippet
      renders each row's piece resolved for the page's selected finish; this file re-resolves a
      row whenever the page's finish changes (#product-variant-id, which dawn-variant-selector.js
      updates and fires change on) or one of the row's selects changes:
        finish  = the page's selected finish when the piece offers it ("matched to your
                  selection"), else the piece's only finish ("In <finish> only"), else the
                  row hides (a multi-finish piece without the page's finish is not offered)
        custom  = while a custom-finishing combo is selected (agcf.js writes it into the ATC
                  form as hidden inputs; the coordinator carries it onto every ticked piece)
                  the line names the combo instead: "In <primary> and <accent>, matched to
                  your selection" (Datch 2026-10-13). The variant still resolves on the page's
                  standard finish. agcf fires no event, so the card watches the form's inputs.
        variant = that finish + the selects' values; when that exact variant is not made or
                  not available the selects fall to the first available combination in the
                  finish; no available variant in the finish = the row hides
      then writes the price (money_without_trailing_zeros style, the server's prefix kept),
      the finish line and the data attributes the coordinator and the probes read. Every row
      hidden = the card hides. The thumb stays the piece's lead image (its gray-background
      studio render; Datch 2026-10-07).
   2. THE ADD / THE PRICE: registered with window.AGAttach as { id: "agsa", on, items,
      total, titles, carry: true (a custom-finishing combo on the page's item is carried onto
      the pieces, plan ruling 5), refused } and refreshed on every change. items() = every
      ticked row's variant. A piece in the page's combo is charged the rate its own page
      charges (Datch 2026-10-13): the row shows that price, the button adds it, and items()
      hands the coordinator the piece's surcharge units (agcf.js window.AGCF.comboPrice).
   3. PRICED MODE (shop.metafields.custom.set_attach_mode = priced; the Arc Set Pricing
      discount active): the card mirrors the discount function EXACTLY
      (arc-set-pricing/extensions/set-pricing/src/run.js): per set, the DISTINCT products
      in the whole cart decide the tier (2 -> 5%, 3+ -> 8%; units never change it), the
      percentage applies to the set's line subtotals, the discounted total is rounded to the
      whole dollar and the discount is split across the lines by largest remainder. The cart
      is read once on load (/cart.js) and again after every add (Datch 2026-10-08: "read the
      cart on load, show the exact figure"), so a cart that already holds a set member shows
      the 8% figure, and so does ticking both rows (desk + shelving + credenza = 3 distinct).
      Once a piece is ticked the card shows "Set price $X" with the separate total struck (D1
      framing, no percent badge, whole dollars) and the main button shows the set figure for
      what this click adds (the page's line and the ticked pieces at their allocated share,
      whole dollars; the chair stays at full price). With other members of the set already in
      the cart, the card's line covers the whole set (the figure checkout shows for the set).
      Custom-finishing surcharges (the page's, the pieces', the set's lines already in the
      cart) ride on top of both figures, never discounted: their product is not a set member.
      Plain mode: no set price, no figure change (regular prices).
      On an UNPUBLISHED theme ?agsa_mode=priced|plain previews that mode without the metafield
      and sticks for the browser session (sessionStorage), so later preview URLs need no parameter.
   4. ANALYTICS (plan C5): ag_set_attach_view (once, on load), ag_set_attach_tick (on / off, per
      row), ag_set_attach_add (the request that carried a piece went through). Each event goes
      to Shopify.analytics.publish (for any web pixel) AND, when the page carries the Google
      channel's gtag (it runs on the top frame), to GA4 through window.gtag with
      send_to G-NSBRHF1SPE, parameters prefixed ag_ (price in cents, booleans as 1/0).
   No navigation, no reload, no dependency beyond the coordinator. */
(function () {
  "use strict";
  if (window.AGSA_BOUND) return;
  window.AGSA_BOUND = true;

  var card = document.querySelector("[data-agsa-card]");
  if (!card) return;
  var island = card.querySelector("[data-agsa-data]");
  var D = null;
  try { D = island ? JSON.parse(island.textContent) : null; } catch (e) { D = null; }
  if (!D || !D.comps || !D.comps.length) return;

  /* the mode: the metafield, or on an UNPUBLISHED theme the ?agsa_mode= preview override, which then sticks for the
     browser session (sessionStorage) so every later preview URL shows the same mode without the parameter */
  var MODE = D.mode === "priced" ? "priced" : "plain";
  try {
    if (card.getAttribute("data-agsa-role") !== "main") {
      var q = new URLSearchParams(location.search).get("agsa_mode");
      var ss = window.sessionStorage;
      if (q === "priced" || q === "plain") {
        MODE = q;
        try { ss.setItem("agsa_mode", q); } catch (e1) { /* storage blocked: per-URL only */ }
      } else {
        var kept = null;
        try { kept = ss.getItem("agsa_mode"); } catch (e2) { kept = null; }
        if (kept === "priced" || kept === "plain") MODE = kept;
      }
    }
  } catch (e) { /* no override */ }
  card.setAttribute("data-agsa-mode", MODE);

  var totalEl = card.querySelector("[data-agsa-total]");
  var totalSet = card.querySelector("[data-agsa-total-set]");
  var totalList = card.querySelector("[data-agsa-total-list]");
  var totalPct = card.querySelector("[data-agsa-total-pct]");

  /* the price line is always in the card's flow (plan 002, 2026-10-09): closed = a 0fr track + visibility hidden,
     open = 1fr; CSS carries the collapse and the fade (ag-set-attach.css). No display toggle, so the card's 8 px row
     gap never steps; the card's bottom padding gives those 8 px back. Transitions retarget, so rapid re-ticks never
     restart from zero. */
  if (totalEl && totalEl.hidden) totalEl.hidden = false;
  function setTotalOpen(on) {
    if (!totalEl) return;
    if (on) totalEl.setAttribute("data-open", "");
    else totalEl.removeAttribute("data-open");
  }
  var cart = null; /* /cart.js items, null until read */

  function parse(txt) {
    var m = /^(\D*?)(\d[\d,]*)(?:\.(\d{1,2}))?(\D*)$/.exec((txt || "").trim());
    if (!m) return null;
    var c = parseInt(m[2].replace(/,/g, ""), 10) * 100 + (m[3] ? parseInt((m[3] + "0").slice(0, 2), 10) : 0);
    return isNaN(c) ? null : { cents: c, tpl: [m[1], m[4]] };
  }
  function money(cents, tpl) {
    var whole = Math.floor(cents / 100);
    var rest = cents % 100;
    var s = String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    if (rest) s += "." + (rest < 10 ? "0" : "") + rest;
    return tpl[0] + s + tpl[1];
  }
  var GA4_ID = "G-NSBRHF1SPE"; /* the store's GA4 stream; the Google channel's gtag configures it on the page */
  /* 2026-10-13 (dry run, finding F1): the Google channel's gtag loads asynchronously, so an event fired before it exists
     (the page-load view) used to be dropped. Events now wait for gtag, polled every 250 ms for up to 20 s, and flush in
     order; nothing else about the send changed. */
  var gaQueue = [], gaTimer = null, gaTicks = 0;
  function gaFlush() {
    if (typeof window.gtag !== "function") return false;
    while (gaQueue.length) { var q = gaQueue.shift(); try { window.gtag("event", q[0], q[1]); } catch (e) { /* never */ } }
    return true;
  }
  function gaEnqueue(name, g) {
    gaQueue.push([name, g]);
    if (gaTimer) return;
    gaTimer = setInterval(function () {
      gaTicks++;
      if (gaFlush() || gaTicks > 80) { clearInterval(gaTimer); gaTimer = null; if (gaTicks > 80) gaQueue.length = 0; }
    }, 250);
  }
  function track(name, payload) {
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === "function") {
        window.Shopify.analytics.publish(name, payload);
      }
    } catch (e) { /* analytics never break the card */ }
    try {
      var g = { send_to: GA4_ID };
      for (var k in payload) {
        if (!Object.prototype.hasOwnProperty.call(payload, k)) continue;
        var v = payload[k];
        if (v === null || v === undefined) continue;
        g["ag_" + k] = typeof v === "boolean" ? (v ? 1 : 0) : v;
      }
      if (!gaQueue.length && typeof window.gtag === "function") window.gtag("event", name, g);
      else gaEnqueue(name, g);
    } catch (e2) { /* analytics never break the card */ }
  }
  function refresh() { if (window.AGAttach) window.AGAttach.refresh(); }

  /* ---------- the rows ---------- */
  var rows = [];
  var rowEls = card.querySelectorAll("[data-agsa-row]");
  for (var ri = 0; ri < rowEls.length; ri++) {
    var el = rowEls[ri];
    var idx = parseInt(el.getAttribute("data-agsa-idx"), 10);
    var comp = D.comps[idx];
    if (!comp || !comp.variants || !comp.variants.length) continue;
    var pe = el.querySelector("[data-agsa-price]");
    var tp = pe ? parse(pe.textContent) : null;
    rows.push({ el: el, idx: idx, comp: comp, check: el.querySelector("[data-agsa-check]"), priceEl: pe, matchEl: el.querySelector("[data-agsa-match]"),
      selects: el.querySelectorAll("[data-agsa-opt]"), label: el.querySelector(".ag-label"), imgEl: el.querySelector("[data-agsa-img]"), imgWant: null,
      tpl: tp ? tp.tpl : ["$", ""], current: null, dead: false, hidden: false });
  }
  if (!rows.length) return;
  var tpl = rows[0].tpl;
  function rowOf(node) {
    var el = node && node.closest ? node.closest("[data-agsa-row]") : null;
    for (var i = 0; i < rows.length; i++) if (rows[i].el === el) return rows[i];
    return null;
  }
  function rowOn(r) { return !r.dead && !r.hidden && !!r.current && !!r.check && r.check.checked && !r.check.disabled; }
  function tickedRows() { var out = []; for (var i = 0; i < rows.length; i++) if (rowOn(rows[i])) out.push(rows[i]); return out; }

  /* ---------- the page's own line ---------- */
  function mainVariantId() {
    var i = document.getElementById("product-variant-id");
    return i ? String(i.value || i.getAttribute("data-variant-id") || "") : "";
  }
  function mainQty() {
    var q = document.getElementById("quantity");
    var v = q ? parseInt(q.value, 10) : 1;
    return v > 0 ? v : 1;
  }
  function mainUnit() {
    var map = (D.main && D.main.priceByVariant) || {};
    var id = mainVariantId();
    return Object.prototype.hasOwnProperty.call(map, id) ? map[id] : null;
  }
  function mainFinish() {
    var id = mainVariantId();
    var map = (D.main && D.main.finishByVariant) || {};
    if (id && Object.prototype.hasOwnProperty.call(map, id)) return map[id];
    return (D.main && D.main.initialFinish) || null;
  }
  /* the page's custom-finishing combo as agcf writes it ("Veined White Marble & Rose Gray Oak", agcf.js a8CartProps;
     no finish name holds "&") and as the coordinator carries it onto the pieces; null while a standard finish is on */
  function atcForm() {
    var b = document.getElementById("add-to-cart-btn");
    return b && b.closest ? b.closest("form") : null;
  }
  function customCombo() {
    var f = atcForm();
    var i = f ? f.querySelector('input[data-agcf14-prop="Custom Finishing"]') : null;
    var v = i ? String(i.value || "").trim() : "";
    return v ? v.split(" & ").join(" and ") : null;
  }
  /* a piece in the page's combo is charged the rate its own page charges (Datch 2026-10-13): agcf.js prices it with its
     own rule (window.AGCF.comboPrice: the combo's codes, the piece's unit price, its standard finish) and the
     coordinator adds its surcharge line. null without a combo or without agcf (then no surcharge is added either). */
  function comboFor(cents, finish) {
    var f = atcForm();
    var i = f ? f.querySelector('input[data-agcf14-prop="_finish_codes"]') : null;
    var codes = i ? String(i.value || "").trim() : "";
    if (!codes || cents === null || !window.AGCF || typeof window.AGCF.comboPrice !== "function") return null;
    try { return window.AGCF.comboPrice(codes, cents, finish || ""); } catch (e) { return null; }
  }
  function pieceCombo(r) { return r.current ? comboFor(r.current.p, r.el.getAttribute("data-agsa-finish")) : null; }
  function piecePrice(r) { var c = pieceCombo(r); return c ? c.price : r.current.p; }

  /* ---------- set custom finishes (Ansen 2026-10-16, canvas MUpB4vs5v52DZuwhEbZYWJ) ----------
     In a custom-finishing combo each row shows its piece in that combo (assets/ag-set-renders.js). A combo the shopper
     only picked is looked up for free (a saved preview shows at once); once they press Generate the pieces render at
     the same moment as the page's own preview. Meanwhile the finish line reads "Rendering in ...", quietly; after a
     width change the picture also fades in and out over a filling bar. A ticked piece carries its own preview into
     the cart as _preview. */
  var pressedPairs = {};
  function comboCodes() {
    var f = atcForm();
    var i = f ? f.querySelector('input[data-agcf14-prop="_finish_codes"]') : null;
    var c = i && window.AGSR ? window.AGSR.codes(i.value) : null;
    return c && c.p ? c : null;
  }
  function comboProps() {
    var f = atcForm(), out = null;
    var names = ["Custom Finishing", "_finish_codes"];
    for (var i = 0; i < names.length; i++) {
      var el = f ? f.querySelector('input[data-agcf14-prop="' + names[i] + '"]') : null;
      if (!el || !el.value) return null;
      (out = out || {})[names[i]] = el.value;
    }
    return out;
  }
  function pageHandle() {
    var n = document.querySelector("[data-agcf-handle]");
    return n ? n.getAttribute("data-agcf-handle") || "" : "";
  }
  function rowReq(r, v) {
    var c = comboCodes();
    if (!c || !v) return null;
    var size = "", ret = "";
    for (var i = 0; i < v.o.length; i++) {
      var s = String(v.o[i] || "");
      if (!size && /\d+\s*[′'’]/.test(s)) size = s;
      if (!ret && /return/i.test(s)) ret = s;
    }
    return { handle: r.comp.handle, p: c.p, a: c.a, side: window.AGSR.sideOf(ret), size: size, lead: pageHandle() };
  }
  function rowBar(r) {
    var a = r.imgEl && r.imgEl.parentNode;
    if (!a || a.querySelector(".agsa-bar")) return;
    var b = document.createElement("span");
    b.className = "agsa-bar";
    b.setAttribute("aria-hidden", "true");
    b.appendChild(document.createElement("span"));
    a.appendChild(b);
  }
  function rowRendering(r, on, loud) {
    r.rendering = !!on;
    if (on && loud) {
      rowBar(r);
      /* round 3: the bar starts where this piece's render really is, never over */
      var sp = r.imgEl && r.imgEl.parentNode ? r.imgEl.parentNode.querySelector(".agsa-bar > span") : null;
      if (sp && window.AGSR && typeof window.AGSR.elapsed === "function") {
        sp.style.animationDelay = (-window.AGSR.elapsed(r.rkey) / 1000).toFixed(2) + "s";
      }
    }
    r.el.classList.toggle("is-rendering", !!(on && loud));
  }
  function showRender(r, url) {
    if (!r.imgEl || !url) return;
    r.imgWant = url;
    if (r.imgEl.getAttribute("src") !== url) r.imgEl.setAttribute("src", url);
    if (r.imgEl.style.transform) r.imgEl.style.transform = "";
  }
  /* true when the row now shows the piece's own preview; else the stock picture paints and the preview may follow */
  function setPic(r, v) {
    var o = window.AGSR ? rowReq(r, v) : null;
    var loud = r.loudNext;
    r.loudNext = false;
    if (!o) { r.rkey = null; rowRendering(r, false); return false; }
    var key = window.AGSR.keyOf(o);
    r.rkey = key;
    var url = window.AGSR.known(o);
    if (url) { rowRendering(r, false); showRender(r, url); return true; }
    var made = !!pressedPairs[o.p + "|" + (o.a || "")];
    /* 2026-10-18 (Ansen: "refresh while it renders - the set card does not fade, the cart does"): a piece whose
       preview started in the last 15 minutes (AGSR keeps the start time across pages) is still being made */
    if (!made && typeof window.AGSR.elapsed === "function") {
      var since = window.AGSR.elapsed(key);
      if (since > 0 && since < 900000) made = true;
    }
    /* Ansen 2026-10-16, round 2: while a piece renders, its picture fades in and out over the loading bar - after a
       Generate as well as after a width change (it was quiet after a Generate in round 1) */
    rowRendering(r, made, made || loud);
    window.AGSR.want(o, made ? null : { probe: true }).then(function (u) {
      if (r.rkey !== key) return;
      rowRendering(r, false);
      if (u) showRender(r, u);
      paintLine(r);
    });
    return false;
  }
  /* the piece's preview for its cart line: the made one, or - while it is being made - the url it will have (the cart
     line then fades over a bar until it lands; Ansen 2026-10-16, round 2) */
  /* round 4 (Ansen 2026-10-16: "if I select 4 ft for the Penfold and refresh, it goes back to 5 ft 3 in - memorize
     those"): each piece's width and return are kept (ag-set-renders.js, shared with the drawer's card) and put back
     on the selects when the page loads; resolve() still falls back when that variant is not available in the finish */
  function sizeRet(vals) {
    var out = { size: "", ret: "" };
    for (var i = 0; i < vals.length; i++) {
      var s = String(vals[i] || "");
      if (!out.size && /\d+\s*[′'’]/.test(s)) out.size = s;
      if (!out.ret && /return/i.test(s)) out.ret = s;
    }
    return out;
  }
  function applyChoices() {
    var SR = window.AGSR;
    if (!SR || typeof SR.choice !== "function") return;
    for (var i = 0; i < rows.length; i++) {
      var c = SR.choice(rows[i].comp.handle);
      if (!c) continue;
      for (var j = 0; j < rows[i].selects.length; j++) {
        var sel = rows[i].selects[j];
        for (var k = 0; k < sel.options.length; k++) {
          var v = sel.options[k].value;
          var hit = (c.size && /\d+\s*[′'’]/.test(v) && SR.inches(v) === SR.inches(c.size))
            || (c.ret && /return/i.test(v) && SR.sideOf(v) === SR.sideOf(c.ret));
          if (hit) { sel.value = v; break; }
        }
      }
    }
  }
  function saveChoice(r) {
    var SR = window.AGSR;
    if (!SR || typeof SR.rememberChoice !== "function" || !r.current) return;
    SR.rememberChoice(r.comp.handle, sizeRet(r.current.o));
  }
  function rowUrl(r) {
    var o = window.AGSR && r.current ? rowReq(r, r.current) : null;
    if (!o) return null;
    return window.AGSR.known(o) || (window.AGSR.pending(o) ? window.AGSR.predict(o) : null);
  }

  /* ---------- resolving a row ---------- */
  function wantFinish(r) {
    var fin = r.comp.finishes || [];
    if (r.comp.finishIndex < 0 || !fin.length) return { finish: null, matched: false };
    var f = mainFinish();
    if (f && fin.indexOf(f) >= 0) return { finish: f, matched: true };
    if (fin.length === 1) return { finish: fin[0], matched: false };
    return null;
  }
  function inFinish(r, v, finish) { return finish === null || v.o[r.comp.finishIndex] === finish; }
  function selOpts(r) {
    var out = [];
    for (var i = 0; i < r.selects.length; i++) out.push({ idx: parseInt(r.selects[i].getAttribute("data-agsa-opt"), 10), val: r.selects[i].value });
    return out;
  }
  function matches(v, opts) {
    for (var i = 0; i < opts.length; i++) if (v.o[opts[i].idx] !== opts[i].val) return false;
    return true;
  }
  function find(r, finish, opts, needAvail) {
    var vs = r.comp.variants;
    for (var i = 0; i < vs.length; i++) {
      var v = vs[i];
      if (!inFinish(r, v, finish)) continue;
      if (needAvail && !v.a) continue;
      if (opts && !matches(v, opts)) continue;
      return v;
    }
    return null;
  }
  // the largest width available in the finish (Ansen 2026-10-16), first listed on a tie: read from the option value
  // written as feet and inches ("9′2″ width")
  function inchesOf(v) {
    for (var i = 0; i < v.o.length; i++) {
      var m = /(\d+)\s*[′'’]\s*(?:(\d+)\s*[″"”])?/.exec(String(v.o[i] || ""));
      if (m) return (+m[1]) * 12 + (+(m[2] || 0));
    }
    return -1;
  }
  function largest(r, finish) {
    var best = null, vs = r.comp.variants;
    for (var i = 0; i < vs.length; i++) {
      var v = vs[i];
      if (!v.a || !inFinish(r, v, finish)) continue;
      if (!best || inchesOf(v) > inchesOf(best)) best = v;
    }
    return best;
  }
  function paintOpts(r, finish) {
    for (var i = 0; i < r.selects.length; i++) {
      var sel = r.selects[i];
      var idx = parseInt(sel.getAttribute("data-agsa-opt"), 10);
      for (var j = 0; j < sel.options.length; j++) {
        var val = sel.options[j].value;
        var ok = false;
        for (var k = 0; k < r.comp.variants.length; k++) {
          var v = r.comp.variants[k];
          if (v.a && inFinish(r, v, finish) && v.o[idx] === val) { ok = true; break; }
        }
        sel.options[j].disabled = !ok;
      }
    }
  }
  function hideRow(r) {
    r.hidden = true;
    if (!r.el.hidden) r.el.hidden = true;
    if (r.check) r.check.checked = false;
    r.current = null;
    var any = false;
    for (var i = 0; i < rows.length; i++) if (!rows[i].hidden) any = true;
    card.hidden = !any;
  }
  function showRow(r) {
    r.hidden = false;
    if (r.el.hidden) r.el.hidden = false;
    if (card.hidden) card.hidden = false;
  }
  /* the thumb follows the resolved variant (finish + return / size selects): the variant's own image when it has one
     (Datch 2026-10-09), else the product's lead image. Preloaded, so a swap never shows a blank frame. */
  function paintImg(r, v) {
    if (!r.imgEl) return;
    if (setPic(r, v)) return;
    var want = (v && v.img) || r.comp.img || "";
    // Ansen 2026-10-16: the variant's picture is the cart's (snippets/ag-variant-pic.liquid); f = it is the other return
    // side's picture, shown flipped
    var flip = !!(v && v.img && v.f) ? "scaleX(-1)" : "";
    if (!want || r.imgEl.getAttribute("src") === want) { r.imgWant = want; if (r.imgEl.style.transform !== flip) r.imgEl.style.transform = flip; return; }
    r.imgWant = want;
    var pre = new Image();
    pre.onload = function () { if (r.imgWant === want && r.imgEl.getAttribute("src") !== want) { r.imgEl.setAttribute("src", want); r.imgEl.style.transform = flip; } };
    pre.src = want;
  }
  function resolve(r) {
    if (r.dead) return;
    var w = wantFinish(r);
    if (!w) return hideRow(r);
    var opts = selOpts(r);
    var v = find(r, w.finish, opts, true);
    if (!v) {
      var first = largest(r, w.finish);
      if (!first) return hideRow(r);
      for (var i = 0; i < r.selects.length; i++) {
        var idx = parseInt(r.selects[i].getAttribute("data-agsa-opt"), 10);
        r.selects[i].value = first.o[idx];
      }
      v = first;
    }
    showRow(r);
    paintOpts(r, w.finish);
    r.current = v;
    r.el.setAttribute("data-variant-id", String(v.id));
    r.el.setAttribute("data-agsa-unit", String(v.p));
    r.el.setAttribute("data-agsa-finish", w.finish || "");
    paintImg(r, v);
    if (r.priceEl) {
      var txt = money(piecePrice(r), r.tpl);
      if (r.priceEl.textContent !== txt) r.priceEl.textContent = txt;
    }
    r.want = w;
    paintLine(r);
    rowLinks(r, v);
    if (r.check && r.check.disabled && !r.dead) r.check.disabled = false;
  }
  /* round 5 (Ansen 2026-10-16: "if we're clicking on a product from a custom finish, pre-enter that custom finish"):
     in a combo, the piece's name and picture open its page at this row's size, in the combo (agcf.js reads agf/agl,
     agl = this page, the piece it was matched to); out of a combo they keep their own link */
  function rowLinks(r, v) {
    var links = r.el.querySelectorAll("a.ag-name, a.ag-thumb");
    var o = window.AGSR ? rowReq(r, v) : null;
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      if (!a.hasAttribute("data-agsa-href0")) a.setAttribute("data-agsa-href0", a.getAttribute("href") || "");
      var base = a.getAttribute("data-agsa-href0");
      var href = base && o ? base.split("?")[0].split("#")[0] + "?variant=" + encodeURIComponent(v.id)
        + "&agf=" + encodeURIComponent(o.p + "." + (o.a || "none") + "." + (o.side || "base"))
        + "&agl=" + encodeURIComponent(o.lead || "") : base;
      if (a.getAttribute("href") !== href) a.setAttribute("href", href);
    }
  }
  /* the finish line; in a combo it reads "Rendering in ..." while the piece's own preview is being made (one line,
     so nothing moves down - Ansen 2026-10-16) */
  function paintLine(r) {
    if (!r.matchEl) return;
    var w = r.want || {};
    var line = "";
    var combo = customCombo(), fe = null;
    if (combo) line = (r.rendering ? "Rendering in " : "In ") + combo + ", matched to your selection";
    else if (w.finish) {
      /* round 4 (Ansen 2026-10-17, board 7A): a standard finish names its accent and shows both dots - the row's variant's
         own finishes (AGSR.finFor: the piece's ag-finish-data view); until they are in, today's words */
      fe = r.current && window.AGSR && typeof window.AGSR.finSync === "function" ? window.AGSR.finSync(r.comp.handle, r.current.id) : null;
      if (!fe && r.current && window.AGSR && window.AGSR.finFor && !r.finAsked) {
        r.finAsked = true;
        window.AGSR.finFor(r.comp.handle).then(function () { paintLine(r); });
      }
      var fname = fe ? window.AGSR.finNames(fe) : w.finish;
      line = w.matched ? "In " + fname + ", matched to your selection" : "In " + fname + " only";
    }
    /* PDP polish (Ansen 2026-10-17, board 2A): in a combo the line starts with a dot of each picked finish, pulsing with
       the picture while the piece renders (AGSR.dots; the dots carry no text, so textContent stays the line) */
    var codesEl = combo ? (atcForm() || document).querySelector('input[data-agcf14-prop="_finish_codes"]') : null;
    var dh = codesEl && window.AGSR && typeof window.AGSR.dots === "function" ? window.AGSR.dots(codesEl.value, !!r.rendering)
      : fe ? window.AGSR.finDots(fe) : "";
    var lineKey = dh + "|" + line;
    if (r.matchEl.getAttribute("data-agsa-line") !== lineKey || r.matchEl.textContent !== line) {
      r.matchEl.setAttribute("data-agsa-line", lineKey);
      if (dh) {
        r.matchEl.innerHTML = dh + "<span></span>";
        r.matchEl.lastChild.textContent = line;
      } else r.matchEl.textContent = line;
    }
    r.matchEl.classList.toggle("has-dots", !!dh);
    r.matchEl.hidden = !line;
    r.el.classList.toggle("nomatch", !line);
  }
  function resolveAll() {
    for (var i = 0; i < rows.length; i++) resolve(rows[i]);
    paintTotal();
    refresh();
  }

  /* ---------- priced mode: the function's arithmetic (run.js) ---------- */
  function setMath(lines) {
    var distinctIds = {};
    var n = 0, subtotal = 0;
    for (var i = 0; i < lines.length; i++) {
      if (!distinctIds[lines[i].productId]) { distinctIds[lines[i].productId] = true; n++; }
      subtotal += lines[i].cents;
    }
    var out = { distinct: n, pct: 0, subtotal: subtotal, total: subtotal, discount: 0, perLine: lines.map(function () { return 0; }) };
    if (n < 2) return out;
    var pct = n >= 3 ? 0.08 : 0.05;
    var desired = Math.round((subtotal * (1 - pct)) / 100) * 100;
    var discount = subtotal - desired;
    if (discount <= 0) return out;
    var shares = lines.map(function (l) { return (discount * l.cents) / subtotal; });
    var floors = shares.map(Math.floor);
    var rest = discount - floors.reduce(function (a, b) { return a + b; }, 0);
    var order = shares.map(function (s, i) { return [s - floors[i], i]; }).sort(function (a, b) { return b[0] - a[0]; });
    for (var k = 0; k < rest; k++) floors[order[k % order.length][1]] += 1;
    out.pct = pct; out.total = desired; out.discount = discount; out.perLine = floors;
    return out;
  }
  window.AGSA_MATH = setMath;

  function setIdSet() {
    var ids = {};
    for (var i = 0; i < (D.setIds || []).length; i++) ids[String(D.setIds[i])] = true;
    return ids;
  }
  /* the cart as it will be after this click: the set's cart lines, then the page's line and every ticked piece
     (each merged into an existing line of the same variant) */
  function projectedLines(withPieces) {
    var ids = setIdSet();
    var lines = [];
    var items = cart || [];
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      if (!it || !ids[String(it.product_id)]) continue;
      lines.push({ productId: String(it.product_id), variantId: String(it.variant_id), cents: it.original_line_price, qty: it.quantity, fromCart: true });
    }
    function add(productId, variantId, unit, qty, tag) {
      // click = what THIS click adds to the line (Ansen 2026-10-16: a cart that already held the same variant made the card
      // and the button show the cart's copy as part of this click, e.g. $9,785 for desk + shelves)
      for (var j = 0; j < lines.length; j++) {
        if (lines[j].variantId === String(variantId)) { lines[j].cents += unit * qty; lines[j].qty += qty; lines[j].click = (lines[j].click || 0) + unit * qty; lines[j][tag] = true; return; }
      }
      var l = { productId: String(productId), variantId: String(variantId), cents: unit * qty, qty: qty, click: unit * qty };
      l[tag] = true;
      lines.push(l);
    }
    var unit = mainUnit();
    if (unit !== null && ids[String(D.main.productId)]) add(D.main.productId, mainVariantId(), unit, mainQty(), "page");
    if (withPieces) {
      var t = tickedRows();
      for (var k = 0; k < t.length; k++) add(t[k].comp.productId, t[k].current.id, t[k].current.p, 1, "piece");
    }
    return lines;
  }
  /* custom-finishing surcharges ride on top of the set figures and are never discounted: the surcharge product is not a
     set member (no custom.set), so the discount function skips its lines (arc-set-pricing run.js). This click's: the
     page's own surcharge (its quantity) and each ticked piece's; the cart's: the surcharge lines already there that
     belong to this set's lines (same codes, same product). */
  function clickSurcharge() {
    var s = 0;
    var unit = mainUnit();
    var main = comboFor(unit, mainFinish());
    if (main) s += (main.price - unit) * mainQty();
    var t = tickedRows();
    for (var i = 0; i < t.length; i++) { var c = pieceCombo(t[i]); if (c) s += c.price - t[i].current.p; }
    return s;
  }
  function cartSurcharge() {
    var ids = setIdSet(), items = cart || [], s = 0;
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      if (!it || String(it.handle || "").indexOf("custom-finishing-surcharge") !== 0) continue;
      var sp = it.properties || {};
      for (var j = 0; j < items.length; j++) {
        var o = items[j];
        if (!o || !ids[String(o.product_id)]) continue;
        if ((o.properties || {})._finish_codes === sp._surcharge_for && (!sp._for_product || sp._for_product === o.handle)) { s += it.original_line_price; break; }
      }
    }
    return s;
  }
  /* the set figure for the ticked pieces */
  function priced() {
    if (MODE !== "priced" || !tickedRows().length) return null;
    var lines = projectedLines(true);
    var m = setMath(lines);
    var otherInCart = false, clickList = 0, clickDisc = 0;
    for (var i = 0; i < lines.length; i++) {
      var l = lines[i];
      // this click's share only: its cents, and the line's discount in proportion (the cart's own copy stays out)
      if (l.click) { clickList += l.click; clickDisc += l.cents ? m.perLine[i] * l.click / l.cents : 0; }
      if (l.fromCart && !l.page && !l.piece) otherInCart = true;
    }
    var sur = clickSurcharge();
    return { math: m, otherInCart: otherInCart, clickList: clickList + sur, clickTotal: clickList - clickDisc + sur,
             clickTotalWhole: Math.round((clickList - clickDisc) / 100) * 100 + sur, sur: sur, cartSur: otherInCart ? cartSurcharge() : 0 };
  }
  /* a figure that changes while the line is open ticks: an instant dip, then a 160 ms rise (plan 003, 2026-10-09) */
  function swapText(el, txt) {
    if (!el || el.textContent === txt) return;
    var open = totalEl && totalEl.hasAttribute("data-open");
    el.textContent = txt;
    if (!open) return;
    el.classList.add("is-swap");
    void el.offsetWidth;
    el.classList.remove("is-swap");
  }
  function paintTotal() {
    if (!totalEl) return;
    var p = priced();
    if (!p || p.math.discount <= 0) { setTotalOpen(false); return; }
    // Ansen 2026-10-16: the line always shows what this click adds (the page's line + the ticked pieces at the set rate);
    // set pieces already in the cart still decide the tier ("Save 8%" with a third piece there) but are not re-added here
    var setPrice = p.clickTotalWhole;
    var list = p.clickList;
    swapText(totalSet, money(setPrice, tpl));
    swapText(totalList, money(list, tpl));
    /* the tier in words: "(Save 5%)" for two distinct pieces, "(Save 8%)" for three or more (Datch 2026-10-08) */
    swapText(totalPct, "(Save " + Math.round(p.math.pct * 100) + "%)");
    setTotalOpen(true);
  }
  function readCart() {
    try {
      return fetch("/cart.js", { headers: { Accept: "application/json" } }).then(function (r) { return r.ok ? r.json() : null; }).then(function (c) {
        cart = c && c.items ? c.items : [];
        paintTotal();
        refresh();
      }, function () { cart = cart || []; });
    } catch (e) { cart = cart || []; return null; }
  }

  /* a piece became unavailable after the page rendered (Shopify refused it at add time) */
  function refuseRow(r) {
    r.dead = true;
    if (r.check) { r.check.checked = false; r.check.disabled = true; }
    r.el.classList.add("is-off");
    for (var i = 0; i < r.selects.length; i++) r.selects[i].disabled = true;
    if (r.label && !r.label.querySelector(".ag-oos")) {
      var s = document.createElement("span");
      s.className = "ag-oos";
      s.textContent = "Not in Stock";
      r.label.appendChild(document.createTextNode(" "));
      r.label.appendChild(s);
    }
  }
  function refused(desc) {
    var d = String(desc || "").toLowerCase();
    var hit = [];
    for (var i = 0; i < rows.length; i++) {
      var t = String(rows[i].comp.title || "").toLowerCase().replace(/\s+/g, " ").trim();
      if (t && d.indexOf(t) >= 0) hit.push(rows[i]);
    }
    if (!hit.length) hit = tickedRows();
    for (var k = 0; k < hit.length; k++) refuseRow(hit[k]);
    paintTotal();
    refresh();
  }

  var api = {
    id: "agsa",
    carry: true,
    on: function () { return tickedRows().length > 0; },
    /* with a combo each piece names its own surcharge line (units at the piece's rate); the coordinator adds it next to
       the piece only when it carries the combo's codes */
    items: function () {
      var t = tickedRows(), out = [];
      for (var i = 0; i < t.length; i++) {
        var c = pieceCombo(t[i]);
        var item = { id: t[i].current.id, quantity: 1, handle: t[i].comp.handle, surcharge: c && c.units ? { id: c.vid, units: c.units } : null };
        /* in a combo the piece carries the combo AND its own preview (the coordinator's carry copies the page's line
           without _preview, so the props are given here instead) */
        var props = comboProps();
        if (props) {
          var u = rowUrl(t[i]);
          if (u) props._preview = u;
          var ro = window.AGSR && window.AGSR.fpOfKey && t[i].current ? rowReq(t[i], t[i].current) : null;
          if (ro) props["Finish preview ID"] = window.AGSR.fpOfKey(window.AGSR.keyOf(ro));   /* 2g: the piece's own ID */
          item.properties = props;
        }
        out.push(item);
      }
      return out;
    },
    /* plain: the ticked pieces at their prices. priced: the exact figure for what this click adds (the page's line and
       the ticked pieces at their allocated share, whole dollars) in place of the theme's text, which the coordinator
       adds to its base: total = figure - base */
    total: function () {
      var t = tickedRows();
      if (!t.length) return 0;
      var plain = 0;
      for (var i = 0; i < t.length; i++) plain += piecePrice(t[i]);
      var p = priced();
      if (!p || p.math.discount <= 0) return plain;
      var base = window.AGAttach && typeof window.AGAttach.base === "function" ? window.AGAttach.base() : null;
      if (base === null) return plain;
      return p.clickTotalWhole - base;
    },
    titles: function () { var out = []; for (var i = 0; i < rows.length; i++) out.push(rows[i].comp.title); return out; },
    refused: refused
  };
  (window.AGAttachQ = window.AGAttachQ || []).push(api);
  if (window.AGAttach) {
    window.AGAttach.onAdded(function (items) {
      readCart();
      for (var i = 0; i < items.length; i++) {
        for (var j = 0; j < rows.length; j++) {
          var r = rows[j];
          if (r.current && String(items[i].id) === String(r.current.id)) {
            track("ag_set_attach_add", { set: D.set, slot: r.comp.slot, handle: r.comp.handle, variant: r.current.id, price: r.current.p, mode: MODE });
          }
        }
      }
    });
  }

  /* ---------- events ---------- */
  card.addEventListener("change", function (e) {
    var t = e.target;
    if (!t) return;
    var r = rowOf(t);
    if (!r) return;
    if (t.hasAttribute("data-agsa-opt")) {
      r.loudNext = true;
      resolve(r);
      saveChoice(r);
      paintTotal();
      refresh();
      return;
    }
    if (t === r.check) {
      paintTotal();
      refresh();
      track("ag_set_attach_tick", { set: D.set, slot: r.comp.slot, handle: r.comp.handle, variant: r.current ? r.current.id : null, price: r.current ? r.current.p : null, on: !!r.check.checked, mode: MODE });
    }
  });
  /* the page's finish (or any variant) or quantity changed */
  function onPage(e) {
    var t = e.target;
    if (!t) return;
    if (t.id === "product-variant-id") { resolveAll(); setTimeout(resolveAll, 60); return; }
    if (t.id === "quantity") { paintTotal(); refresh(); }
  }
  window.addEventListener("change", onPage, true);
  window.addEventListener("input", onPage, true);
  window.addEventListener("click", function (e) {
    var t = e.target;
    if (t && t.closest && t.closest("#add-to-cart-container .qty-minus, #add-to-cart-container .qty-plus")) setTimeout(function () { paintTotal(); refresh(); }, 0);
  }, true);
  window.addEventListener("pageshow", function () { resolveAll(); readCart(); });
  /* the shopper pressed Generate (agcf.js): the pieces render now, beside the page's own preview */
  window.addEventListener("agcf:generate", function (e) {
    var d = (e && e.detail) || {};
    if (d.p) pressedPairs[d.p + "|" + (d.a || "")] = true;
    setTimeout(resolveAll, 400);
  });
  window.addEventListener("agsr:boot", function () { resolveAll(); });
  /* agcf's combo changed (a pick, an accent added or removed, a clear): a hidden input's value is its value attribute,
     so an observer on the ATC form sees every write; only a change of the combo's text repaints */
  var lastCombo = customCombo();
  var form = atcForm();
  if (form && window.MutationObserver) {
    new MutationObserver(function () {
      var c = customCombo();
      if (c === lastCombo) return;
      lastCombo = c;
      resolveAll();
    }).observe(form, { childList: true, subtree: true, attributes: true, attributeFilter: ["value"] });
  }

  window.AGSA_STATE = function () {
    var p = priced();
    var rs = [];
    for (var i = 0; i < rows.length; i++) {
      var r = rows[i];
      rs.push({ slot: r.comp.slot, handle: r.comp.handle, hidden: r.hidden, dead: r.dead, checked: !!(r.check && r.check.checked), variant: r.current ? r.current.id : null,
                price: r.current ? r.current.p : null, shownPrice: r.current ? piecePrice(r) : null, finish: r.el.getAttribute("data-agsa-finish"), opts: selOpts(r),
                label: r.label ? r.label.textContent.replace(/\s+/g, " ").trim() : null, match: r.matchEl ? r.matchEl.textContent : null });
    }
    var first = rs[0] || {};
    return { mode: MODE, pageKind: D.pageKind, hidden: !!card.hidden, custom: customCombo(), rows: rs,
             /* first-row shorthand, kept for the probes */
             dead: !!first.dead, checked: !!first.checked, variant: first.variant || null, price: first.price || null, finish: first.finish || null, opts: first.opts || [],
             label: first.label || null, match: first.match || null,
             mainFinish: mainFinish(), mainUnit: mainUnit(), mainQty: mainQty(), cartRead: cart !== null, cartSetLines: projectedLines(false).length,
             priced: p ? { distinct: p.math.distinct, pct: p.math.pct, subtotal: p.math.subtotal, total: p.math.total, discount: p.math.discount,
                           perLine: p.math.perLine, otherInCart: p.otherInCart, clickList: p.clickList, clickTotal: p.clickTotal, clickTotalWhole: p.clickTotalWhole,
                           sur: p.sur, cartSur: p.cartSur } : null,
             totalShown: totalEl ? totalEl.hasAttribute("data-open") : null, totalText: totalEl && totalEl.hasAttribute("data-open") ? (totalSet.textContent + " / " + totalList.textContent) : null };
  };

  applyChoices();
  resolveAll();
  readCart();
  for (var vi = 0; vi < rows.length; vi++) {
    track("ag_set_attach_view", { set: D.set, slot: rows[vi].comp.slot, handle: rows[vi].comp.handle, variant: rows[vi].current ? rows[vi].current.id : null, price: rows[vi].current ? rows[vi].current.p : null, mode: MODE });
  }
})();
